export enum IK_ACL_STATUS {
    StatusKeyForbidden = '301',
    StatusPrivate = '302',
    StatusTrashed = '303',
    StatusSuspendedChannel = '304',
    StatusIPForbidden = '305',
    StatusCountryForbidden = '306',
    StatusDomainForbidden = '307',
    StatusInvalidToken = '401',
    StatusFutureToken = '402',
    StatusPastToken = '403',
    StatusTokenNotFound = '404',
    StatusTokenMismatch = '405',
    StatusTokenMaxUsageReached = '406',
    StatusBadPassword = '407',
    StatusInternalError = '500',
}

// export interface ISourceHeaders {
//     contentLength: string;
//     contentType': string;
//     'x-ik-acl-status': string;
//     'x-ik-acl-status-literal': string;
// }
